import React, { useState, useEffect, useCallback, useMemo } from 'react';
import propTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';

import EquipmentScheduleOrderHeader from './EquipmentScheduleOrderHeader/EquipmentScheduleOrderHeader';
import PageLoader from '../../components/PageLoader';
import styles from './styles';
// import { drawerTypes } from './components/helpers/drawerTypes';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllEquipmentData } from 'store/equipment/equipmentPageOperations';
import { fetchEquipmentColorGroupsAndOrder, patchEquipmentColorGroupOrder, patchEquipmentOrder } from 'store/equipment/equipmentScheduleOrderPageOperations';
import EquipmentOrderList from './EquipmentOrderList/EquipmentOrderList';
import EquipmentScheduleOrderButtonBar from './EquipmentScheduleOrderButtonBar/EquipmentScheduleOrderButtonBar';
import OptionalModal from 'components/OptionalModal/OptionalModal';

const EquipmentScheduleOrderPage = ({ classes, openSnackbar }) => {
  const dispatch = useDispatch()
  const [confirmDialog, setConfirmDialog] = useState({ isOpen: false });
  
  const userTenantLocationId = useSelector((store) => store.personalProfile.organizationLocation?._id);
  const { organization } = useSelector((store) => store.personalProfile);
  const { locations: allLocations } = useSelector((store) => store.settings);
  const [tenantLocationId, setTenantLocationId] = useState(userTenantLocationId);
  const [loading, setLoading] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);
  
  const locations = useMemo(() => allLocations.filter(location => !!location.active), [allLocations]);

  useEffect(() => {
    dispatch(fetchAllEquipmentData({ companyWide: true }));
    dispatch(fetchEquipmentColorGroupsAndOrder({ tenantLocationId }))
  }, []);

  useEffect(() => {
    dispatch(fetchEquipmentColorGroupsAndOrder({ tenantLocationId }))
  }, [tenantLocationId])

  const { data: allEquipment, isLoading: isEquipmentLoading } = useSelector((store) => store.equipment);
  const { colorGroups: allColorGroups, equipmentOrderInColorGroups: allEquipmentOrderInColorGroups } = useSelector((store) => store.equipmentScheduleOrder)

  const equipment = useMemo(
    () => allEquipment?.filter(eq => eq.assignedToLocations?.includes(tenantLocationId)) || [],
    [allEquipment, tenantLocationId]
  );
  const colorGroups = useMemo(
    () => (
      tenantLocationId
        ? allColorGroups[tenantLocationId] || []
        : []
      ),
    [allColorGroups, tenantLocationId]
  );
  const equipmentOrderInColorGroups = useMemo(
    () => (
      tenantLocationId
        ? allEquipmentOrderInColorGroups[tenantLocationId] || []
        : []
      ),
    [allEquipmentOrderInColorGroups, tenantLocationId]
  );

  const onMoveEquipment = useCallback((equipmentId, color, orderInColorGroup) => {
    dispatch(patchEquipmentOrder(equipmentId, color, orderInColorGroup, tenantLocationId))
  }, [tenantLocationId]);

  const onMoveColorGroup = useCallback((groupId, orderNumber) => {
    dispatch(patchEquipmentColorGroupOrder(groupId, orderNumber, tenantLocationId))
  }, [tenantLocationId]);

  const handleConfirmDialogSubmit = async () => {
    if (confirmDialog?.onSubmit) await confirmDialog.onSubmit();
    setConfirmDialog({ isOpen: false });
  }

  const openConfirmDialog = (confirmDialogOptions) => {
    setConfirmDialog({ isOpen: true, ...confirmDialogOptions });
  }

  return (
    <div className={classes.root}>
      <EquipmentScheduleOrderHeader />

      {(organization?.settings?.multiLocations && locations?.length > 1)
        ? (<EquipmentScheduleOrderButtonBar
          tenantLocationId={tenantLocationId}
          locations={locations}
          setTenantLocation={setTenantLocationId}
        />)
        : null
      }

      <PageLoader loading={loading}>
         <EquipmentOrderList
            equipment={equipment}
            colorGroups={colorGroups}
            equipmentOrderInColorGroups={equipmentOrderInColorGroups}
            locations={locations}
            onMoveEquipment={onMoveEquipment}
            onMoveColorGroup={onMoveColorGroup}
            openConfirmDialog={openConfirmDialog}
          />
      </PageLoader>

      {confirmDialog.isOpen ? (
        <OptionalModal
          isOpen={confirmDialog.isOpen}
          onClose={() => setConfirmDialog({ isOpen: false })}
          onCancel={() => setConfirmDialog({ isOpen: false })}
          onSave={handleConfirmDialogSubmit}
          options={{ ...confirmDialog, cancelBtnText: 'Cancel', saveBtnText: 'Yes', textVariant: 'h6', titleVariant: 'h4' }}
        />
      ) : null}
    </div>
  );
};


EquipmentScheduleOrderPage.propTypes = {
  classes: propTypes.object.isRequired,
  openSnackbar: propTypes.func.isRequired,
};

export default withStyles(styles)(EquipmentScheduleOrderPage);
